var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.checkTag,{tag:"component",staticClass:"button",attrs:{"href":_vm.buttonHref,"to":_vm.buttonTo,"value":_vm.buttonValue},on:{"click":_vm.emitClickButton}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }